export const estilos = {
    fontSize: 14,
    lineHeight: 1.6,
    wordBreak: 'break-word',
    '& p': { m: 0, mb: 1 },
    '& p:last-child': { mb: 0 },
    '& h3': { fontSize: 16, fontWeight: 700, m: 0, mb: 1 },
    '& ul, & ol': { pl: 3, my: 1 },
    '& li': { mb: 0.5 },
    '& blockquote': {
        m: 0,
        my: 1,
        pl: 1.5,
        borderLeft: '3px solid',
        borderColor: 'divider',
        color: 'text.secondary',
    },
    '& a': { color: 'primary.main', textDecoration: 'underline' },
};